<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<mat-tab-group>
  <mat-tab label="Roles">
    <ng-template matTabContent>
      <app-admin-system-roles></app-admin-system-roles>
    </ng-template>
  </mat-tab>
  <mat-tab label="EventTemplate Roles">
    <ng-template matTabContent>
      <app-admin-event-template-roles></app-admin-event-template-roles>
    </ng-template>
  </mat-tab>
  <mat-tab label="Event Roles">
    <ng-template matTabContent>
      <app-admin-event-roles></app-admin-event-roles>
    </ng-template>
  </mat-tab>
</mat-tab-group>